import * as React from "react";
import { QuickAction } from "@lupp/shared";

export interface QuickActionsProps {
  actions: QuickAction[];
  onSelect: (action: QuickAction) => void;
}

export default class QuickActions extends React.Component<QuickActionsProps> {
  render(): JSX.Element {
    const { actions, onSelect } = this.props;

    return (
      <div className="quick-actions" aria-label="Schnellaktionen">
        <div className="quick-actions__grid">
          {actions.map((action) => (
            <button key={action.id} className="quick-actions__btn" type="button" onClick={(): void => onSelect(action)}>
              <span className="quick-actions__title">{action.title}</span>
              <span className="quick-actions__sub">{action.prompt}</span>
            </button>
          ))}
        </div>
      </div>
    );
  }
}
